import { createSelector } from "reselect";
import { isEmpty } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const mobile = state.profile.mobile;
  if (isEmpty(mobile)) {
    return null;
  }

  if (mobile.mobile) {
    return mobile.mobile;
  } else {
    return null;
  }
};

const getMemberMobileNumber = createSelector(getData, mobile => mobile);
export default getMemberMobileNumber;



// WEBPACK FOOTER //
// ./src/_selectors/profileSelectors/getMemberMobileNumber.js